<script>
    import {router} from "../lib/Router/Router.svelte";
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import Checkbox from "../components/controls/Checkbox.svelte";
    import {setFocusTo} from "../lib/lib";


    export let account = null;
    export let updateCallback;


    const save = () => {
        const onSuccess = result => {
            let changeRouter = account.id == 0;
            account = result;
            updateCallback(account);
            Notifier.showMessage("Account saved");
            if (changeRouter) {
                router.go(`/app/account/${account.id}`)();
            }
        }

        const onFailure = err => {
            Alert.warning("Account", err.message);
        };

        account.name = account.name.trim();
        if (!account.name) {
            Notifier.showError("Type the name of the account!");
            setFocusTo('accountName');
            return;
        }

        let action = account.id === 0 ? 'create' : 'edit';
        R.handle(R.account[action], account, onSuccess, onFailure, LOADER.POPUP);
    }
</script>

{#if account}
    <div class="panel border-default mb-6">
        <div class="panel-body panel-pad">
            <form autocomplete="off">
                <div class="row">
                    <div class="form-group">
                        <h5>Account name</h5>
                        <input type="text" class="form-control" id="accountName"
                               bind:value="{ account.name }" autocomplete="off">
                    </div>
                    <div class="col-xl-6 col-lg-7">
                        <div class="form-group">
                            <label>Contact person</label>
                            <input type="text" class="form-control" bind:value="{ account.contact_person }"
                                   autocomplete="off">
                        </div>
                        <div class="form-group">
                            <label>Phone</label>
                            <input type="tel" class="form-control" bind:value="{ account.phone }"
                                   autocomplete="off">
                        </div>
                        <div class="form-group">
                            <label>Mobile</label>
                            <input type="tel" class="form-control" bind:value="{ account.mobile }"
                                   autocomplete="off">
                        </div>
                        <div class="form-group">
                            <label>Email</label>
                            <input type="email" class="form-control" bind:value="{ account.email }"
                                   autocomplete="off">
                        </div>
                    </div>
                    <div class="col-xl-6">
                        <div class="form-group">
                            <label>Address</label>
                            <input type="text" class="form-control" bind:value="{ account.address }"
                                   autocomplete="off">
                        </div>
                        <div class="form-group">
                            <label>Vat</label>
                            <input type="text" class="form-control" bind:value="{ account.vat }"
                                   autocomplete="off">
                        </div>
                        <div class="form-group">
                            <label>Tax Office</label>
                            <input type="text" class="form-control" bind:value="{ account.tax_office }"
                                   autocomplete="off">
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label>Notes</label>
                    <textarea class="form-control" bind:value="{ account.notes }"></textarea>
                </div>
                <div class="form-group">
                    <Checkbox label="Active account" bind:checked={ account.is_active }/>
                </div>
            </form>
            <hr>
            <div class="text-end">
                <button class="btn btn-primary px-4" on:click="{ save }">SAVE</button>
            </div>
        </div>
    </div>
{/if}